"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertEmbed = exports.insertClip = exports.insertLinkClip = exports.insertQuoteClip = exports.insertImageClip = exports.insertableLoaded = exports.clipLinkLoaded = exports.insertQuestionAndAnswer = exports.insertVideo = exports.insertImage = exports.restoreSelection = exports.removeHighlightedSummaryText = exports.removeHighlightedTitleText = exports.removeHighlightedBodyText = exports.highlightSummaryText = exports.highlightTitleText = exports.highlightBodyText = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("composer-plugins/lib/constants");

var _constants2 = require("composer-lib/lib/constants");

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var highlightBodyText = function highlightBodyText(highlightData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.HIGHLIGHT_BODY_TEXT)(highlightData));
  };
};

exports.highlightBodyText = highlightBodyText;

var highlightTitleText = function highlightTitleText() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.HIGHLIGHT_TITLE_TEXT)());
  };
};

exports.highlightTitleText = highlightTitleText;

var highlightSummaryText = function highlightSummaryText() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.HIGHLIGHT_SUMMARY_TEXT)());
  };
};

exports.highlightSummaryText = highlightSummaryText;

var removeHighlightedBodyText = function removeHighlightedBodyText() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REMOVE_HIGHLIGHTED_BODY_TEXT)());
  };
};

exports.removeHighlightedBodyText = removeHighlightedBodyText;

var removeHighlightedTitleText = function removeHighlightedTitleText() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REMOVE_HIGHLIGHTED_TITLE_TEXT)());
  };
};

exports.removeHighlightedTitleText = removeHighlightedTitleText;

var removeHighlightedSummaryText = function removeHighlightedSummaryText() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.REMOVE_HIGHLIGHTED_SUMMARY_TEXT)());
  };
};

exports.removeHighlightedSummaryText = removeHighlightedSummaryText;

var restoreSelection = function restoreSelection(selection) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.RESTORE_SELECTION_AFTER_MANUAL_FOCUS)(selection));
  };
};

exports.restoreSelection = restoreSelection;

var insertImage = function insertImage(imageData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_IMAGE)(imageData));
  };
};

exports.insertImage = insertImage;

var insertVideo = function insertVideo(videoData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_VIDEO)(videoData));
  };
};

exports.insertVideo = insertVideo;

var insertQuestionAndAnswer = function insertQuestionAndAnswer(questionId) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_QUESTION_AND_ANSWER)({
      questionId: questionId
    }));
  };
};

exports.insertQuestionAndAnswer = insertQuestionAndAnswer;

var clipLinkLoaded = function clipLinkLoaded() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.CLIP_LINK_LOADED)());
  };
};

exports.clipLinkLoaded = clipLinkLoaded;

var insertableLoaded = function insertableLoaded() {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERTABLE_LOADED)());
  };
};

exports.insertableLoaded = insertableLoaded;

var insertImageClip = function insertImageClip(clipData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_IMAGE_CLIP)(clipData));
  };
};

exports.insertImageClip = insertImageClip;

var insertQuoteClip = function insertQuoteClip(clipData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_QUOTE_CLIP)(clipData));
  };
};

exports.insertQuoteClip = insertQuoteClip;

var insertLinkClip = function insertLinkClip(clipData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_LINK_CLIP)(clipData));
  };
};

exports.insertLinkClip = insertLinkClip;

var insertClip = function insertClip(clip) {
  var insertSrc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'preview';
  return function (dispatch) {
    var clipType = clip.get('type');
    var insertType;
    var meta;

    if (clipType === _constants.CLIP_TYPES.IMAGE) {
      insertType = "image-" + insertSrc;
    } else if (clipType === _constants.CLIP_TYPES.QUOTE) {
      insertType = "quote-" + insertSrc;
    }

    if (insertType) {
      meta = (0, _defineProperty2.default)({}, _constants2.TRACK_EVENT_META_KEY, {
        action: 'collect-insert',
        extra: {
          'collect-insert-type': insertType
        },
        name: _constants2.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
      });
    }

    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_CLIP)(clip, meta));
  };
};

exports.insertClip = insertClip;

var insertEmbed = function insertEmbed(embedData) {
  return function (dispatch) {
    dispatch((0, _utils.createAction)(_ActionTypes.default.INSERT_EMBED)(embedData));
  };
};

exports.insertEmbed = insertEmbed;